<ion-grid class="card-container" data-cy="alert-group-card">
  <!-- Description Row - Full width for tablet, part of single row for others -->
  <ion-row
    *ngIf="
      platformService?.platformType === platformService?.platformEnum?.tablet
    "
  >
    <ion-col [size]="12" class="card-description">
      <div class="card-description-container">
        <span class="card-description-title" data-cy="alert-group-name">{{
          'i18n.notifications.preferences.' + alertGroup?.name + '_NAME'
            | translate
        }}</span>
        <span class="card-description-text" data-cy="alert-group-description">{{
          alertGroupDescription | translate
        }}</span>
      </div>
    </ion-col>
  </ion-row>

  <!-- Main Content Row -->
  <ion-row>
    <!-- Description Column - Only show for non-tablet -->
    <ion-col
      *ngIf="
        platformService?.platformType !== platformService?.platformEnum?.tablet
      "
      [size]="
        platformService?.platformType === platformService?.platformEnum?.desktop
          ? '4'
          : '12'
      "
      class="card-description"
    >
      <div class="card-description-container">
        <span class="card-description-title" data-cy="alert-group-name">{{
          'i18n.notifications.preferences.' + alertGroup?.name + '_NAME'
            | translate
        }}</span>
        <span class="card-description-text" data-cy="alert-group-description">{{
          alertGroupDescription | translate
        }}</span>
      </div>
    </ion-col>

    <!-- Notification Types Column -->
    <ion-col
      [size]="
        platformService?.platformType === platformService?.platformEnum?.tablet
          ? '4'
          : platformService?.platformType ===
              platformService?.platformEnum?.desktop
            ? '2.5'
            : '12'
      "
      class="card-notification-types"
    >
      <span
        class="card-notification-type-title"
        [class.alert-disabled]="
          !alertGroup?.availableDeliveryMethods?.includes('PUSH') &&
          !user?.email?.length
        "
        data-cy="notification-type-title"
        >{{ 'i18n.notifications.preferences.notificationType' | translate }}
      </span>
      <div class="card-notification-type-container">
        <ion-button
          [class]="
            !user?.email?.length
              ? 'usf-clear-disabled-button'
              : alertGroup?.enabledDeliveryMethods?.includes('EMAIL')
                ? 'usf-fill-green-button'
                : 'usf-clear-green-button'
          "
          [disabled]="!user?.email?.length"
          data-cy="email-only-button"
          (click)="toggleNotificationType(['EMAIL'])"
        >
          {{ 'Email' }}
        </ion-button>
        <ion-button
          [class]="
            !alertGroup?.availableDeliveryMethods?.includes('PUSH')
              ? 'usf-clear-disabled-button'
              : alertGroup?.enabledDeliveryMethods?.includes('PUSH')
                ? 'usf-fill-green-button'
                : 'usf-clear-green-button'
          "
          [disabled]="!alertGroup?.availableDeliveryMethods?.includes('PUSH')"
          data-cy="push-only-button"
          (click)="toggleNotificationType(['PUSH'])"
        >
          {{ 'i18n.notifications.preferences.pushAlert' | translate }}
        </ion-button>
      </div>
    </ion-col>

    <!-- Customers Column -->
    <ion-col
      [size]="
        platformService?.platformType === platformService?.platformEnum?.tablet
          ? '4'
          : platformService?.platformType ===
              platformService?.platformEnum?.desktop
            ? '2.5'
            : '12'
      "
      class="card-customers"
    >
      <span
        class="card-customers-title"
        [class.alert-disabled]="
          !alertGroup?.availableDeliveryMethods?.includes('PUSH') &&
          !user?.email?.length
        "
        data-cy="customers-title"
        >{{ 'i18n.notifications.preferences.customers' | translate }}</span
      >
      <div class="card-customers-toggle-container">
        <span
          class="card-customers-toggle-label"
          [class.alert-disabled]="
            !alertGroup?.availableDeliveryMethods?.includes('PUSH') &&
            !user?.email?.length
          "
          data-cy="all-off-label"
          >{{ 'i18n.notifications.preferences.allOff' | translate }}</span
        >
        <ion-toggle
          mode="ios"
          slot="end"
          [checked]="
            alertGroup?.enabledCustomers?.length === availableCustomers?.length
          "
          [disabled]="
            !alertGroup?.availableDeliveryMethods?.includes('PUSH') &&
            !user?.email?.length
          "
          data-cy="customers-toggle"
          (ionChange)="toggleAllCustomers($event)"
        ></ion-toggle>
        <span
          class="card-customers-toggle-label"
          [class.alert-disabled]="
            !alertGroup?.availableDeliveryMethods?.includes('PUSH') &&
            !user?.email?.length
          "
          data-cy="all-on-label"
          >{{ 'i18n.notifications.preferences.allOn' | translate }}</span
        >
      </div>
    </ion-col>

    <!-- Manage Customers Column -->
    <ion-col
      [size]="
        platformService?.platformType === platformService?.platformEnum?.tablet
          ? '4'
          : platformService?.platformType ===
              platformService?.platformEnum?.desktop
            ? '3'
            : '12'
      "
      class="card-manage-customers"
    >
      <div class="card-manage-customers-container">
        <ion-button
          class="card-manage-customers-button"
          [class.alert-disabled]="
            !alertGroup?.availableDeliveryMethods?.includes('PUSH') &&
            !user?.email?.length
          "
          data-cy="manage-customers-button"
          (click)="manageCustomers()"
          [disabled]="
            !alertGroup?.availableDeliveryMethods?.includes('PUSH') &&
            !user?.email?.length
          "
          >{{ 'i18n.notifications.preferences.manageCustomers' | translate
          }}<ion-icon name="chevron-forward-outline"></ion-icon
        ></ion-button>
        <span
          class="card-manage-customers-text"
          data-cy="enabled-customers-count"
          *ngIf="alertGroup?.enabledCustomers?.length > 0"
          >{{
            alertGroup?.enabledCustomers?.length +
              ('i18n.notifications.preferences.of' | translate) +
              availableCustomers?.length
          }}</span
        >
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
